// extracted by mini-css-extract-plugin
export default {"container":"About_container__EtJWU","text":"About_text__gacuF","image":"About_image__YNS4I"};